import { render, staticRenderFns } from "./ItemListMisuraCliente.vue?vue&type=template&id=65786393"
import script from "./ItemListMisuraCliente.vue?vue&type=script&lang=ts"
export * from "./ItemListMisuraCliente.vue?vue&type=script&lang=ts"
import style0 from "./ItemListMisuraCliente.vue?vue&type=style&index=0&id=65786393&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65786393')) {
      api.createRecord('65786393', component.options)
    } else {
      api.reload('65786393', component.options)
    }
    module.hot.accept("./ItemListMisuraCliente.vue?vue&type=template&id=65786393", function () {
      api.rerender('65786393', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mtm/ItemListMisuraCliente.vue"
export default component.exports